import NiceModal from '@ebay/nice-modal-react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import ModuleToolTipContainer from 'components/global/ModuleToolTipContainer';
import Tooltip from 'components/global/Tooltip';
import Typography from 'components/global/Typography';

import useAppTracking from 'hooks/useAppTracking';

import PATHS from 'utils/paths';

import { faCheck, faExpandAlt, faGear } from '@fortawesome/pro-regular-svg-icons';
import { faEye, faLock } from '@fortawesome/pro-solid-svg-icons';

import Button from './Button';
import * as S from './styled/TemplateSelector.styled';

/**
 * @author Ömer Dursun
 */

const ImageModal = NiceModal.create(({ imageUrl }) => (
	<Modal fullwidth maxWidth="medium" className="modal-templateSelector">
		<S.TemplateImage width="100%" height="100%" url={imageUrl} alt="image" referrerPolicy="no-referrer" />
	</Modal>
));

const TemplateSelector = ({
	imageUrl,
	disabled,
	isConfigurable,
	name,
	className,
	checkAction,
	configAction,
	disabledTitle = 'customizableFreeLockedTemplateTitle',
	disabledDescription = 'customizableFreeLockedTemplateSubtitle'
}) => {
	const { t } = useTranslation();
	const { track } = useAppTracking();
	const navigate = useNavigate();

	return (
		<S.TemplateSelectorContainer>
			<S.Miniscreen className={className}>
				<S.DarkContainer className="dark-container">
					<S.IconDiv>
						{!disabled && (
							<Tooltip title="view" placement="bottom">
								<Button
									size="small"
									icon={faExpandAlt}
									onClick={() => {
										NiceModal.show(ImageModal, { imageUrl });
									}}
								/>
							</Tooltip>
						)}
						{!disabled && checkAction && className !== 'selected' && (
							<Tooltip title="select" placement="bottom">
								<Button size="small" icon={faCheck} onClick={checkAction} />
							</Tooltip>
						)}
						{!disabled && isConfigurable && configAction && (
							<Tooltip title="settings" placement="bottom">
								<Button size="small" icon={faGear} onClick={configAction} />
							</Tooltip>
						)}
						{disabled && (
							<div style={{ display: 'block' }}>
								<Tooltip
									timeout={100}
									placement="bottom"
									color="var(--white)"
									title={(closePopper) => (
										<div style={{ display: 'block' }}>
											<ModuleToolTipContainer
												infoImage="lottie_smsLottie"
												title={disabledTitle}
												description={disabledDescription}
											/>

											<Button
												style={{ marginLeft: 'Auto', marginRight: 'Auto' }}
												className="mt-3"
												label="showPlans"
												icon={faEye}
												variant="blue"
												onClick={() => {
													track('moreThan1Template');
													navigate(PATHS.OTO_MODULES);
													closePopper();
												}}
											/>
										</div>
									)}>
									<Button variant="black" size="small" icon={faLock} />
								</Tooltip>
							</div>
						)}
					</S.IconDiv>
				</S.DarkContainer>

				<Image url={imageUrl} width={'20rem'} height="12rem" alt="image" />
				{className === 'selected' && <div className="selected-badge">{t('selectedTemplate')}</div>}
			</S.Miniscreen>
			<Typography fontWeight="500" fullWidth align="center" style={{ paddingBottom: '.5rem' }}>
				{name}
			</Typography>
		</S.TemplateSelectorContainer>
	);
};

TemplateSelector.propTypes = {
	/** Image url. Required props*/
	imageUrl: PropTypes.string.isRequired
};

export default TemplateSelector;
